module.exports = __webpack_public_path__ + "static/media/020.bed4cf9c.jpg";